export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukces"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
}